import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceKey, getMemberSpaceMembershipRequestKey, } from '../../utils/keys';
export const useRequestSpaceMembership = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.spaceMembership.request(input), {
        onSettled: (data, error, variables) => {
            const spaceKey = getSpaceKey({ variables: { id: variables.spaceId } });
            queryClient.invalidateQueries(spaceKey);
            queryClient.invalidateQueries(getMemberSpaceMembershipRequestKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useRequestSpaceMembership.js.map